import React, { useState, useEffect } from 'react';

import { Header, Heading, Label, Title, Count, ShowMoreContainer } from './StyledFilterGroup';

import { FilterGroupMeta, FilterMeta } from '.';

import Checkbox from '_utils/components/Corporate/Checkbox';
import ShowMore from '_utils/components/Corporate/ShowMore';
import { includesId } from '_utils/data';
import { useTranslation } from 'react-i18next';

type FilterOptionProps = {
  filter: FilterMeta;
  parentId: string;
  checked: boolean;
  onChange: (e) => void;
};

type FilterGroupProps = {
  parentId: string;
  selectedFilters: string[];
  filterGroup: FilterGroupMeta;
  onChange: (e) => void;
};

const FilterOption: React.FC<FilterOptionProps> = ({
  filter: { title, numResults, id },
  parentId,
  checked,
  onChange
}) => 
   (
    <Checkbox
      id={`content-type-checkbox-${parentId}-${id}`}
      name="filterOption"
      value={id}
      onChange={onChange}
      checked={checked}
    >
      <Label>
        <Title className={checked ? 'selected' : ''}>{title}</Title>
        {(numResults || numResults === 0) && <Count> ({numResults})</Count>}
      </Label>
    </Checkbox>
  );

const FilterGroup: React.FC<FilterGroupProps> = ({
  parentId,
  filterGroup,
  selectedFilters,
  onChange
}) => {
  const results = filterGroup?.results || [];
  const title = filterGroup?.title || null;
  const primaryResults = results.slice(0, 4);
  const secondaryResults = results.slice(4);
  const [canShowMore, setCanShowMore] = useState(secondaryResults.length > 0);
  const [showingMore, setShowingMore] = useState(false);
  const [t] = useTranslation();

  useEffect(() => {
    setCanShowMore(secondaryResults && secondaryResults.length > 0 && !showingMore);
  }, [secondaryResults, showingMore]);

  if (!filterGroup) {
    return null;
  }

  return (
    <div data-parent={parentId}>
      <Header>
        <Heading>{filterGroup.title}</Heading>
      </Header>
      {primaryResults &&
        primaryResults.map((result) => (
          <FilterOption
            key={`FilterOption-${result.id}`}
            filter={result}
            parentId={parentId}
            checked={includesId(selectedFilters, result.id)}
            onChange={onChange}
          />
        ))}
      {canShowMore && (
        <ShowMoreContainer>
          <ShowMore
            label={t('search-filter-category-show-more-label')}
            title={title}
            count={secondaryResults.length}
            onClick={() => {
              setShowingMore(true);
              setCanShowMore(false);
            }}
          />
        </ShowMoreContainer>
      )}
      {showingMore &&
        secondaryResults &&
        secondaryResults.map((result) => (
          <FilterOption
            key={`FilterOption-${result.id}`}
            filter={result}
            parentId={parentId}
            checked={includesId(selectedFilters, result.id)}
            onChange={onChange}
          />
        ))}
    </div>
  );
};

export default FilterGroup;
